export default "__VITE_ASSET__Dx_$GDTZ__"